module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section03_02_american-village-3e1e0eac5b33a805659406d403fe1672.jpg";